import { initializeApp } from "@firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "@firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification, applyActionCode } from "@firebase/auth";
import { getStorage } from "@firebase/storage";
import { getFunctions } from "@firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyATejkrZ5fx6-CLcwxlDlzK5nTvvfkV3Xc",
  authDomain: "whoseitemisthis.firebaseapp.com",
  projectId: "whoseitemisthis",
  storageBucket: "whoseitemisthis.appspot.com",
  messagingSenderId: "777232814226",
  appId: "1:777232814226:web:879bbb8663cd3a7a6ed64b",
  measurementId: "G-HZDCJZ58V4"
};

// Initialize Firebase services
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Set persistence
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Auth persistence set to local');
    }
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

// Enable offline persistence for Firestore
enableIndexedDbPersistence(db)
  .then(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Firestore persistence enabled');
    }
  })
  .catch((error) => {
    console.error('Error enabling Firestore persistence:', error);
  });

export { app, db, auth, storage, functions, applyActionCode }; 
